<template lang="pug">
nav.navbar.is-fixed-top(role="navigation" aria-label="main navigation")
  .navbar-brand
    a.navbar-item(href="/")
      img(src="../../assets/logo.svg" width="150")
    a.navbar-burger(role="button" aria-label="menu" aria-expanded="false")
      span(aria-hidden="true")
      span(aria-hidden="true")
      span(aria-hidden="true")
  .nabvar-menu(v-if="displayCountDown") {{displayCountDown}}
</template>

<script>
export default {
  name: 'Header',
  data(){
    return {
      countDownDisplayString: ''
    }
  },
  computed: {
    displayCountDown(){
      return this.countDownDisplayString
    }
  },
  mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
</style>
